


function animateCategories(){
    anime({
        targets: '.categories .col-md-3',
        scale: [
            {value: .1, easing: 'easeOutSine', duration: 500},
            {value: 1, easing: 'easeInOutQuad', duration: 1200}
        ],
        delay: anime.stagger(200, {grid: [4, 5], from: 'center'})
    });
}